import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useState } from 'react';

const TextEditor = ({ value = "", onChange }) => {
  const [editorData, setEditorData] = useState(value);

  return (
    <div className="ckeditor-wrapper">
      <CKEditor
        editor={ClassicEditor}
        data={editorData}
        onChange={(event, editor) => {
          const data = editor.getData();
          setEditorData(data);
          if (onChange) onChange(data);
        }}
      />
    </div>
  );
};

export default TextEditor;